import { addOperator, removeOperator, replaceOperator } from "./lww.js";
import _defineProperty from "../_virtual/_@oxc-project_runtime@0.151.0/helpers/esm/defineProperty.js";
//#region ../erd-editor-schema/dist/query/index.js
var Query = class {
	constructor(collections) {
		_defineProperty(this, "collections", void 0);
		this.collections = collections;
	}
	collection(collection) {
		return new CollectionQuery(this.collections[collection], collection);
	}
};
var CollectionQuery = class {
	constructor(collection, collectionKey) {
		_defineProperty(this, "collection", void 0);
		_defineProperty(this, "collectionKey", void 0);
		this.collection = collection;
		this.collectionKey = collectionKey;
	}
	selectById(id) {
		return this.collection[id];
	}
	selectByIds(ids) {
		ids.length;
		return ids.map((id) => this.selectById(id)).filter(Boolean);
	}
	selectEntities() {
		return this.collection;
	}
	selectAll() {
		return Object.values(this.collection);
	}
	setOne(entity) {
		this.collection[entity.id] = entity;
		return this;
	}
	setMany(entities) {
		entities.forEach((entity) => this.setOne(entity));
		return this;
	}
	setAll(entities) {
		this.removeAll();
		this.setMany(entities);
		return this;
	}
	addOne(entity) {
		if (this.selectById(entity.id)) return this;
		this.setOne(entity);
		return this;
	}
	addMany(entities) {
		entities.forEach((entity) => this.addOne(entity));
		return this;
	}
	removeOne(id) {
		if (this.selectById(id)) Reflect.deleteProperty(this.collection, id);
		return this;
	}
	removeMany(ids) {
		ids.forEach((id) => this.removeOne(id));
		return this;
	}
	removeAll() {
		this.collection = {};
		return this;
	}
	updateOne(id, recipe) {
		const entity = this.selectById(id);
		if (entity) recipe(entity);
		return this;
	}
	updateMany(ids, recipe) {
		ids.forEach((id) => this.updateOne(id, recipe));
		return this;
	}
	getOrCreate(id, recipe) {
		const entity = this.selectById(id);
		if (entity) return entity;
		const newEntity = recipe(id);
		this.setOne(newEntity);
		return this.selectById(id);
	}
	addOperator(lww, version, id, recipe) {
		addOperator(lww, version, id, this.collectionKey, recipe);
		return this;
	}
	removeOperator(lww, version, id, recipe) {
		removeOperator(lww, version, id, this.collectionKey, recipe);
		return this;
	}
	replaceOperator(lww, version, id, path, recipe) {
		replaceOperator(lww, version, id, this.collectionKey, path, recipe);
		return this;
	}
};
var query = (collections) => new Query(collections);
//#endregion
export { query };
